import React, { useState } from "react";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import "./AddStocks.css"; // Import the CSS file
import { useAlert } from "react-alert";

const INITIAL_TRADE = {
  currency: "",
  entryPrice: "",
  takeProfit: "",
  stopLoss: "",
  positionType: "Long",
  marginUsedUSDT: "",
  status: "Open",
  pnlUSDT: "",
  roiPercent: "",
};

const autoPositionType = (entry, tp) => {
  const e = parseFloat(entry);
  const t = parseFloat(tp);
  if (!isNaN(e) && !isNaN(t) && e !== t) return e < t ? "Long" : "Short";
  return null;
};

export function Addstocks({ getPosts, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [inputData, setInputData] = useState({
    description: "",
    img: "",
    format: "",
    video: "",
    pdfFile: "",
  });

  const [tradeType, setTradeType] = useState(null);
  const [stockTrade, setStockTrade] = useState(INITIAL_TRADE);
  const [forexTrade, setForexTrade] = useState(INITIAL_TRADE);

  const handleStockChange = (e) => {
    const updated = { ...stockTrade, [e.target.name]: e.target.value };
    if (e.target.name === "entryPrice" || e.target.name === "takeProfit") {
      if (e.target.name === "takeProfit" && !e.target.value) {
        updated.positionType = "Long";
      } else {
        const pos = autoPositionType(updated.entryPrice, updated.takeProfit);
        if (pos) updated.positionType = pos;
      }
    }
    setStockTrade(updated);
  };
  const handleForexChange = (e) => {
    const updated = { ...forexTrade, [e.target.name]: e.target.value };
    if (e.target.name === "entryPrice" || e.target.name === "takeProfit") {
      if (e.target.name === "takeProfit" && !e.target.value) {
        updated.positionType = "Long";
      } else {
        const pos = autoPositionType(updated.entryPrice, updated.takeProfit);
        if (pos) updated.positionType = pos;
      }
    }
    setForexTrade(updated);
  };
  const handleTradeTypeChange = (type) => {
    setTradeType(type === tradeType ? null : type);
    setStockTrade(INITIAL_TRADE);
    setForexTrade(INITIAL_TRADE);
  };

  const handleSubmit = async () => {
    try {
      if (tradeType) {
        const activeTrade = tradeType === "stock" ? stockTrade : forexTrade;
        if (
          activeTrade.currency &&
          (!activeTrade.marginUsedUSDT ||
            Number(activeTrade.marginUsedUSDT) <= 0)
        ) {
          alert.error("Balance Used (USD) must be greater than 0");
          return;
        }
      }
      if (inputData.description || tradeType) {
        setLoader(true);
        let payload = {
          _id: adminStore.admin.admin._id,
          description: inputData.description || "",
          imageTitle: inputData.img || "",
          imageFormat: inputData.format || "",
          video: inputData?.video || "",
          pdfFile: inputData?.pdfFile || "",
          tradeType: tradeType || null,
          stockTrade: tradeType === "stock" ? stockTrade : null,
          forexTrade: tradeType === "forex" ? forexTrade : null,
        };

        const signalResponse = await api.stocksCreate(payload);
        if (signalResponse?.success) {
          setInputData({
            description: "",
            img: "",
            format: "",
            video: "",
            pdfFile: "",
          });
          setTradeType(null);
          setStockTrade(INITIAL_TRADE);
          setForexTrade(INITIAL_TRADE);
          setLoader(false);
          setSelectedImg([]);
          setSelectedPDF(null);
          getPosts();
          setShow(false);
        } else {
          setLoader(false);
          alert.error("Something went wrong");
        }
      } else {
        setLoader(false);
        alert.error("Please add a description or select a trade type");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.error("Something went wrong");
    }
  };

  const sendNotification = async () => {
    try {
      const signalResponse = await api.sendPostMailToAllUser();
      if (signalResponse?.success) {
        alert.success("email sent to all users");
      }
    } catch (error) {
      alert.error("Something went wrong");
    }
  };

  const Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const onFileChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      for (let file of e.target.files) {
        formData.append("image", file);
      }
      const uploadRes = await api.uploadFile(formData);

      let newImages = [];
      var imgName = uploadRes[0].split(",");
      var imgFormat = uploadRes[1].split(",");
      for (let i = 0; i < imgName.length; i++) {
        newImages.push(
          `${process.env.REACT_APP_S3URL}/img_${imgName[i]}.${imgFormat[i]}`,
        );
      }

      // append to existing instead of replacing
      setSelectedImg((prev) => [...prev, ...newImages]);
      setInputData((prev) => ({
        ...prev,
        img: prev.img ? `${prev.img},${uploadRes[0]}` : uploadRes[0],
        format: prev.format ? `${prev.format},${uploadRes[1]}` : uploadRes[1],
      }));
      setLoader(false);
    } catch (e) {
      alert.error("File upload failed");
      setLoader(false);
      console.log(e);
    }
  };

  const removeImage = (index) => {
    const newImgs = selectedImg.filter((_, i) => i !== index);
    setSelectedImg(newImgs);
    const names = inputData.img ? inputData.img.split(",") : [];
    const formats = inputData.format ? inputData.format.split(",") : [];
    names.splice(index, 1);
    formats.splice(index, 1);
    setInputData((prev) => ({
      ...prev,
      img: names.join(","),
      format: formats.join(","),
    }));
  };

  const onPDFChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      formData.append("pdf", e.target.files[0], e.target.files[0].name);
      const uploadRes = await api.uploadPDF(formData);

      setSelectedPDF(`${process.env.REACT_APP_S3URL}/${uploadRes}`);
      setInputData({
        ...inputData,
        pdfFile: `${uploadRes}`,
      });
      setLoader(false);
    } catch (e) {
      alert.error("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  const handleChange = (e) => {
    setInputData({ ...inputData, description: e });
  };

  return (
    <>
      <div className="add-stocks-container">
        <div className="add-stocks-header">
          <div className="header-content">
            <h1 className="page-title">Add Stocks</h1>
            <p className="page-text">
              Create a new stock & commodity trade post
            </p>
          </div>
        </div>

        <div className="add-stocks-card">
          <div className="card-header">
            <h3 className="card-title">Post Details</h3>
            <p className="card-description">
              Fill in the details below to create a new stock post
            </p>
          </div>

          <div className="card-body">
            {/* ── Trade Details ── */}
            <div className="form-section">
              <div className="form-section-header">
                <div className="section-title">
                  <h3 className="section-title-text">
                    <i className="fas fa-chart-line me-2"></i>Trade Details
                    (Optional)
                  </h3>
                  <p className="section-subtitle">
                    Attach structured trade data to this post
                  </p>
                </div>
                {tradeType && (
                  <div className="section-status">
                    <span className="status-badge status-active">
                      {tradeType === "stock" ? "📈 Stock" : "🌍 Forex"}
                    </span>
                  </div>
                )}
              </div>

              <div className="trade-type-toggle">
                <button
                  type="button"
                  className={`trade-type-btn ${tradeType === "stock" ? "active-spot" : ""}`}
                  onClick={() => handleTradeTypeChange("stock")}
                >
                  <i className="fas fa-chart-bar me-2"></i>Stock
                </button>
                <button
                  type="button"
                  className={`trade-type-btn ${tradeType === "forex" ? "active-futures" : ""}`}
                  onClick={() => handleTradeTypeChange("forex")}
                >
                  <i className="fas fa-globe me-2"></i>Forex
                </button>
                {tradeType && (
                  <button
                    type="button"
                    className="trade-type-btn trade-type-clear"
                    onClick={() => setTradeType(null)}
                  >
                    <i className="fas fa-times me-2"></i>Clear
                  </button>
                )}
              </div>

              {tradeType === "stock" && (
                <div className="trade-fields-container trade-fields-spot">
                  <div className="trade-fields-badge">
                    <i className="fas fa-chart-bar"></i> Stock Trade
                  </div>
                  <div className="trade-grid">
                    <div className="trade-field">
                      <label className="trade-label">Ticker</label>
                      <input
                        type="text"
                        name="currency"
                        className="trade-input"
                        placeholder="e.g. APLD, NVDA"
                        value={stockTrade.currency}
                        onChange={handleStockChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Entry Price</label>
                      <input
                        type="number"
                        name="entryPrice"
                        className="trade-input"
                        placeholder="e.g. 27.22"
                        value={stockTrade.entryPrice}
                        onChange={handleStockChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">
                        Take Profit (Target)
                      </label>
                      <input
                        type="number"
                        name="takeProfit"
                        className="trade-input"
                        placeholder="e.g. 31.20"
                        value={stockTrade.takeProfit}
                        onChange={handleStockChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Stop Loss</label>
                      <input
                        type="number"
                        name="stopLoss"
                        className="trade-input"
                        placeholder="e.g. 25.50"
                        value={stockTrade.stopLoss}
                        onChange={handleStockChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Balance Used (USD)</label>
                      <input
                        type="number"
                        name="marginUsedUSDT"
                        className="trade-input"
                        placeholder="e.g. 500"
                        value={stockTrade.marginUsedUSDT}
                        onChange={handleStockChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Position Type</label>
                      <select
                        name="positionType"
                        className="trade-input trade-select"
                        value={stockTrade.positionType}
                        onChange={handleStockChange}
                      >
                        <option value="Long">Long (Buy)</option>
                        <option value="Short">Short (Sell)</option>
                        <option value="Spot">Spot</option>
                      </select>
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Status</label>
                      <select
                        name="status"
                        className="trade-input trade-select"
                        value={stockTrade.status}
                        onChange={handleStockChange}
                      >
                        <option value="Open">Open</option>
                        <option value="Closed">Closed</option>
                        <option value="TP Hit">TP Hit</option>
                        <option value="SL Hit">SL Hit</option>
                      </select>
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">PNL (USDT)</label>
                      <input
                        type="number"
                        name="pnlUSDT"
                        className="trade-input"
                        placeholder="e.g. 320"
                        value={stockTrade.pnlUSDT}
                        onChange={handleStockChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">ROI (%)</label>
                      <div className="trade-input-suffix">
                        <input
                          type="number"
                          name="roiPercent"
                          className="trade-input"
                          placeholder="e.g. 6.4"
                          value={stockTrade.roiPercent}
                          onChange={handleStockChange}
                        />
                        <span className="suffix-label">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {tradeType === "forex" && (
                <div className="trade-fields-container trade-fields-futures">
                  <div className="trade-fields-badge futures-badge">
                    <i className="fas fa-globe"></i> Forex Trade
                  </div>
                  <div className="trade-grid">
                    <div className="trade-field">
                      <label className="trade-label">Pair</label>
                      <input
                        type="text"
                        name="currency"
                        className="trade-input"
                        placeholder="e.g. GBP/USD, XAU/USD"
                        value={forexTrade.currency}
                        onChange={handleForexChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Entry Price</label>
                      <input
                        type="number"
                        name="entryPrice"
                        className="trade-input"
                        placeholder="e.g. 1.2955"
                        value={forexTrade.entryPrice}
                        onChange={handleForexChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Take Profit (TP)</label>
                      <input
                        type="number"
                        name="takeProfit"
                        className="trade-input"
                        placeholder="e.g. 1.2865"
                        value={forexTrade.takeProfit}
                        onChange={handleForexChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Stop Loss (SL)</label>
                      <input
                        type="number"
                        name="stopLoss"
                        className="trade-input"
                        placeholder="e.g. 1.3020"
                        value={forexTrade.stopLoss}
                        onChange={handleForexChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Balance Used (USD)</label>
                      <input
                        type="number"
                        name="marginUsedUSDT"
                        className="trade-input"
                        placeholder="e.g. 500"
                        value={forexTrade.marginUsedUSDT}
                        onChange={handleForexChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Position Type</label>
                      <select
                        name="positionType"
                        className="trade-input trade-select"
                        value={forexTrade.positionType}
                        onChange={handleForexChange}
                      >
                        <option value="Long">Long (Buy)</option>
                        <option value="Short">Short (Sell)</option>
                        <option value="Spot">Spot</option>
                      </select>
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">Status</label>
                      <select
                        name="status"
                        className="trade-input trade-select"
                        value={forexTrade.status}
                        onChange={handleForexChange}
                      >
                        <option value="Open">Open</option>
                        <option value="Closed">Closed</option>
                        <option value="TP Hit">TP Hit</option>
                        <option value="SL Hit">SL Hit</option>
                      </select>
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">PNL (USDT)</label>
                      <input
                        type="number"
                        name="pnlUSDT"
                        className="trade-input"
                        placeholder="e.g. 200"
                        value={forexTrade.pnlUSDT}
                        onChange={handleForexChange}
                      />
                    </div>
                    <div className="trade-field">
                      <label className="trade-label">ROI (%)</label>
                      <div className="trade-input-suffix">
                        <input
                          type="number"
                          name="roiPercent"
                          className="trade-input"
                          placeholder="e.g. 0.40"
                          value={forexTrade.roiPercent}
                          onChange={handleForexChange}
                        />
                        <span className="suffix-label">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* ── End Trade Details ── */}

            <div className="form-section">
              <label className="form-label">Description</label>
              <div className="rich-text-editor">
                <ReactQuill
                  placeholder="Write your stock analysis, market insights, or trading recommendations here..."
                  modules={Editor}
                  theme="snow"
                  value={inputData.description}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-section">
              <label className="form-label">Video Embed (Optional)</label>
              <textarea
                name="video"
                value={inputData?.video}
                className="form-control video-input"
                onChange={(e) =>
                  setInputData({ ...inputData, video: e.target.value })
                }
                placeholder="Paste video iframe code here..."
                rows="3"
              ></textarea>
            </div>

            <div className="form-row">
              <div className="form-section">
                <label className="form-label">Upload Images</label>
                <div className="file-upload-area image-upload">
                  <label className="file-upload-label">
                    <input
                      name="file"
                      onChange={onFileChange}
                      accept="image/*"
                      type={"file"}
                      multiple
                      className="file-input"
                    />
                    <div className="upload-content">
                      <div className="upload-icon">
                        <i className="icon-upload"></i>
                      </div>
                      <div className="upload-text">
                        <h4>Click to upload images</h4>
                        <p>PNG, JPG, GIF up to 10MB each</p>
                      </div>
                      <div className="upload-button">Browse Files</div>
                    </div>
                  </label>
                </div>

                <div className="image-preview-container">
                  {selectedImg.length > 0 && (
                    <>
                      <div className="preview-header">
                        <span>Uploaded Images ({selectedImg.length})</span>
                      </div>
                      <div className="image-grid">
                        {selectedImg.map((val, key) => (
                          <div
                            className="image-card"
                            key={key}
                            style={{ position: "relative" }}
                          >
                            <img
                              className="preview-image"
                              src={val}
                              alt={`Uploaded ${key + 1}`}
                            />
                            <div className="image-overlay">
                              <span className="image-number">{key + 1}</span>
                            </div>
                            <button
                              onClick={() => removeImage(key)}
                              style={{
                                position: "absolute",
                                bottom: 4,
                                right: 4,
                                background: "rgba(0,0,0,0.6)",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: 22,
                                height: 22,
                                cursor: "pointer",
                                fontSize: 13,
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 10,
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="form-section">
                <label className="form-label">Upload Document (Optional)</label>
                <div className="file-upload-area document-upload">
                  <label className="file-upload-label">
                    <input
                      name="file"
                      onChange={onPDFChange}
                      accept=".pdf,.doc,.docx"
                      type={"file"}
                      className="file-input"
                    />
                    <div className="upload-content">
                      <div className="upload-icon">
                        <i className="icon-document"></i>
                      </div>
                      <div className="upload-text">
                        {selectedPDF ? (
                          <>
                            <h4>Document Uploaded</h4>
                            <p>Click to download or replace</p>
                          </>
                        ) : (
                          <>
                            <h4>Click to upload document</h4>
                            <p>PDF, DOC, DOCX up to 25MB</p>
                          </>
                        )}
                      </div>
                      <div className="upload-button">
                        {selectedPDF ? "Change File" : "Browse Files"}
                      </div>
                    </div>
                  </label>

                  {selectedPDF && (
                    <div className="document-preview">
                      <div className="document-info">
                        <div className="document-icon">
                          <i className="icon-pdf"></i>
                        </div>
                        <div className="document-details">
                          <div className="document-name">
                            {inputData?.pdfFile?.split("/").pop() ||
                              "uploaded_file"}
                          </div>
                          <a
                            href={selectedPDF}
                            download={inputData?.pdfFile}
                            className="download-link"
                          >
                            <i className="icon-download"></i> Download
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="btn-primary"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <span className="spinner"></span>
                    Creating Post...
                  </>
                ) : (
                  "Create Post"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {loader && (
        <div className="loader-overlay">
          <div className="loader-container">
            <div className="loader-spinner">
              <div className="spinner-circle"></div>
              <div className="spinner-circle"></div>
              <div className="spinner-circle"></div>
            </div>
            <p className="loader-text">Creating your stock post...</p>
          </div>
        </div>
      )}
    </>
  );
}
